
import { AgeTagType, StaticPageType, SurveyCsvData } from "@/store/types";
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";

const SurveyModule = namespace("survey");
const SystemModule = namespace("system");
@Options({
  components: {},
})
export default class SurveyExit extends Vue {
  @SurveyModule.Getter("byAgeTag")
  private byAgeTag!: AgeTagType;

  @SurveyModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  @SurveyModule.Getter("surveyData")
  private surveyData!: SurveyCsvData;

  @SystemModule.Action("routerExternalLink")
  private routerExternalLink!: (tag: StaticPageType) => void;

  @SurveyModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  public isVisible = false;

  public async mounted(): Promise<void> {
    await this.updateIsWhiteout(false);
    this.isVisible = true;
  }

  public get isHiraganaWord() {
    return this.byAgeTag === "UNDER_10";
  }

  public get titleWord() {
    let word = "ご協力いただきありがとうございました。";
    if (this.isHiraganaWord) {
      word = "おしえて いただき、 ありがとう ございました。";
    }
    return word;
  }

  public get subtitleWord() {
    let word =
      "じぶんフォントプロジェクトでは、アンケートをディスレクシアの研究に役立てます。\n\nさらにプロジェクトの活動について知りたい、参加したい場合は、\n下記のリンクからお問合わせや、研究へのご参加をお待ちしております。";
    if (this.isHiraganaWord) {
      word =
        "じぶんフォントプロジェクトでは、 アンケートを もとに、\nあなたが よめる もじの かたちを かんがえます。\n\nもっと「じぶんフォント」について しりたい、 てつだいたい ばあいは、\nしつもんや けんきゅうの さんかを おまちして おります。";
    }
    return word;
  }

  public get toEdge() {
    let word = "ディスレクシアについてくわしく見てみる（NPO EDGEのページへ）";
    if (this.isHiraganaWord) {
      word = "ディスレクシアに ついて くわしく みる";
    }
    return word;
  }

public get toContactUsWordA() {
    let word = "問い合わせ（DNPのサイトの問い合わせフォームへ）";
    if (this.isHiraganaWord) {
      word = "しつもん する";
    }
    return word;
  }

  public get toDyslexiaReserchWordB() {
    let word = "研究についてくわしく見てみる（朱助教のプロジェクトのページへ）";
    if (this.isHiraganaWord) {
      word = "けんきゅうに ついて しる";
    }
    return word;
  }

  public get buttonWordC() {
    let word = "アンケートを終わる";
    if (this.isHiraganaWord) {
      word = "アンケートを おわる";
    }
    return word;
  }
}
